import React from 'react'
import ContentWrapper from '../../Layout/ContentWrapper'
import { Row, Col, Button, Card, CardBody, Input, CardFooter } from 'reactstrap'
import axios from 'axios'
import { DeleteDialogBox } from '../../Common/'
import FormValidator from '../../Forms/FormValidator.js'
import pubsub from 'pubsub-js'

class EditWorkingStatus extends React.Component {
  constructor() {
    super()
    this.state = {
      isEdit: false,
      formWorkingStatus: {
        nameWorkingStatus: ''
      }
    }
  }

  validateOnChange = (event) => {
    const input = event.target
    const form = input.form
    const value = input.type === 'checkbox' ? input.checked : input.value
    const result = FormValidator.validate(input)

    this.setState({
      [form.name]: {
        ...this.state[form.name],
        [input.name]: value,
        errors: {
          ...this.state[form.name].errors,
          [input.name]: result
        }
      }
    })
  }

  hasError = (formName, inputName, method) => {
    return (
      this.state[formName] &&
      this.state[formName].errors &&
      this.state[formName].errors[inputName] &&
      this.state[formName].errors[inputName][method]
    )
  }

  deleteButton(id) {
    const goBack = () => this.props.history.goBack()
    const path = `works/${id}`
    const name = 'Statusin e punës'
    DeleteDialogBox({ path, name, goBack })
  }

  onSubmit = (e) => {
    const ID = this.props.match.params.idWorkingStatus
    const form = e.target
    const inputs = [...form.elements].filter((i) => ['INPUT', 'SELECT'].includes(i.nodeName))

    const { errors, hasError } = FormValidator.bulkValidate(inputs)
    this.setState({
      [form.name]: {
        ...this.state[form.name],
        errors
      }
    })

    if (!hasError) {
      const postData = {
        name: this.state.formWorkingStatus.nameWorkingStatus
      }
      if (ID) {
        axios
          .put(`works/${ID}`, postData)
          .then((res) => {
            if (res.data.success) {
              this.props.history.push('/workingStatus')
              pubsub.publish('showNotification', {
                message: 'Të dhënat janë ndryshuar!',
                type: 'success'
              })
            } else {
              pubsub.publish('showNotification', {
                message: res.data.message,
                type: 'error'
              })
            }
          })

          .catch((err) => {
            pubsub.publish('showNotification', {
              message: 'Gabim gjatë ruajtjes së të dhënave',
              type: 'error'
            })
          })
      } else {
        axios
          .post('works', postData)
          .then((res) => {
            if (res.data.success) {
              pubsub.publish('showNotification', {
                message: 'Të dhënat janë ruajtur!',
                type: 'success'
              })
              this.props.history.push('/workingStatus')
            } else {
              pubsub.publish('showNotification', {
                message: res.data.message,
                type: 'error'
              })
            }
          })
          .catch((err) => {
            pubsub.publish('showNotification', {
              message: 'Gabim gjatë ruajtjes të të dhënave',
              type: 'error'
            })
          })
      }
    }

    e.preventDefault()
  }

  async componentDidMount() {
    const ID = this.props.match.params.idWorkingStatus
    if (ID) {
      try {
        const res = await axios.get('works/' + ID, {})
        this.setState({
          isEdit: true,
          formWorkingStatus: {
            nameWorkingStatus: res.data.data.name
          }
        })
      } catch (error) {}
    }
  }

  render() {
    const id = this.props.match.params.idWorkingStatus
    return (
      <ContentWrapper>
        {this.state.isEdit ? (
          <div className='d-flex justify-content-between'>
            <p style={{ fontSize: 23, color: 'gray' }}>Modifiko Statusine e Punës</p>
            <div>
              <Button onClick={() => this.props.history.goBack()} color='info' className='btn-labeled'>
                <span className='btn-label'>
                  <i className='fa fa-arrow-left' />
                </span>{' '}
                Prapa
              </Button>
            </div>
          </div>
        ) : (
          <div className='d-flex justify-content-between'>
            <p style={{ fontSize: 23, color: 'gray' }}>Shto Status Pune</p>
            <div>
              <Button onClick={() => this.props.history.goBack()} color='info' className='btn-labeled'>
                <span className='btn-label'>
                  <i className='fa fa-arrow-left' />
                </span>{' '}
                Prapa
              </Button>
            </div>
          </div>
        )}
        <Row>
          <div className='col-md-12'>
            <form onSubmit={this.onSubmit} name='formWorkingStatus'>
              {/* START card */}
              <Card className='card-default'>
                <CardBody>
                  <legend className='mb-4' />
                  <fieldset>
                    <div className='form-group row align-items-center'>
                      <label className='col-md-2 col-form-label'>Emri i Statusit :</label>
                      <Col md={6}>
                        <Input
                          key='nameWorkingStatus'
                          type='text'
                          name='nameWorkingStatus'
                          invalid={this.hasError('formWorkingStatus', 'nameWorkingStatus', 'required')}
                          onChange={this.validateOnChange}
                          value={this.state.formWorkingStatus.nameWorkingStatus}
                          data-validate='["required"]'
                        />
                        <span className='invalid-feedback'>Fusha është e nevojshme</span>
                      </Col>
                    </div>
                  </fieldset>
                </CardBody>
                {this.state.isEdit ? (
                  <CardFooter className='text-right'>
                    <button style={{ marginRight: 10 }} type='submit' className='btn btn-info'>
                      Ruaj / Modifiko
                    </button>
                    <Button
                      color='danger'
                      onClick={() => {
                        this.deleteButton(id)
                      }}
                    >
                      Fshije
                    </Button>
                  </CardFooter>
                ) : (
                  <CardFooter className='text-right'>
                    <button type='submit' className='btn btn-info'>
                      Ruaj
                    </button>
                  </CardFooter>
                )}
              </Card>
              {/* END card */}
            </form>
          </div>
        </Row>
      </ContentWrapper>
    )
  }
}

export default EditWorkingStatus
